import { store } from 'redux/store';

import normalizeCif from 'utils/normalizeCif';

import { getPartnerIdentifiers } from 'modules/partners/api/getPartnerIdentifiers';

export type ConstitutionExistingPartner = {
  _id: string;
  cif: string;
};

export const fetchExistingPartnersForConstitution = async (
  societyId: string
): Promise<ConstitutionExistingPartner[]> => {
  const partners = (await store.dispatch(
    getPartnerIdentifiers(societyId)
  )) as { _id: string; cif?: string }[] | undefined;

  if (!partners?.length) {
    return [];
  }

  return partners.reduce<ConstitutionExistingPartner[]>((acc, partner) => {
    if (!partner?._id) {
      return acc;
    }

    const cif = normalizeCif(partner.cif || '');
    if (!cif) {
      return acc;
    }

    acc.push({ _id: partner._id, cif });
    return acc;
  }, []);
};
